var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPool = function SvgPool(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.752,
    d: "M5.838 25.198V5.427c-.287-3.74 3.153-4.055 5.89-4.055m12.629 23.826V5.427c-.287-3.74 3.153-4.055 5.877-4.055M11.27 9.037h12.757M11.27 15.355h12.757M11.27 21.372h12.757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.93 27.748c-1.06 0-2.135.243-3.196.73a3.02 3.02 0 0 1-2.881 0c-1.82-.974-4.415-.974-6.235 0a3.02 3.02 0 0 1-2.881 0c-1.835-.974-4.415-.974-6.236 0l-2.279 1.233c-.616.358-.76 1.103-.3 1.705.444.616 1.361.745 2.12.372l2.28-1.218a2.98 2.98 0 0 1 2.895 0c1.82.974 4.4.974 6.221 0a2.98 2.98 0 0 1 2.895 0c1.82.974 4.4.974 6.236 0a2.95 2.95 0 0 1 2.88 0l2.28 1.218c.76.373 1.677.244 2.121-.372.459-.602.316-1.347-.444-1.705l-2.28-1.232c-1.074-.488-2.135-.731-3.196-.731"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPool);
export default ForwardRef;